import axios from 'axios';
import EnvironmentUtils from '../utils/environment-utils';
import {
  applyAccessTokenInterceptor,
  applyPendingRequestCountInterceptor, applyTokenExpirationInterceptor,
} from './axios-interceptors';

const EnrouteApiV2Client = axios.create({
  baseURL: EnvironmentUtils.getVar('API_ENROUTE_V2'),
});

applyAccessTokenInterceptor(EnrouteApiV2Client);
applyPendingRequestCountInterceptor(EnrouteApiV2Client);
applyTokenExpirationInterceptor(EnrouteApiV2Client)

export default EnrouteApiV2Client;
